<template>
    <label class="radio__label">
        <input type="radio" :value="id" :name="name" v-model="radioButtonValue" class="radio__input">
        <span class="radio__tick"></span>
        {{ label }}
    </label>
</template>

<script>
export default {
    name: 'totem-radio',
    props: {
        value: {
            type: String
        },
        label: {
            type: String
        },
        name: {
            type: String
        },
        id: {
            type: String
        }
    },
    computed: {
        radioButtonValue: {
            get: function () {
                return this.value
            },
            set: function () {
                this.$emit('change', this.id)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.radio {
    &__label {
        display: flex;
        align-items: center;
        margin-right: 10px;
        position: relative;
        cursor: pointer;
    }

    &__input[type="radio"] {
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }

    &__tick {
        width: 18px;
        height: 18px;
        border: 1px solid $carbon;
        border-radius: 50%;
        margin-right: 10px;
        position: relative;
    }

    &__label input[type="radio"]:checked+.radio__tick::before,
    &__label input[type="radio"]:not(:checked)+.radio__tick::before {
        content: "";
        background-color: $rust_orange;
        border-radius: 50%;
        position: absolute;
        width: 12px;
        height: 12px;
        transition: all 0.2s ease;
        top: 50%;
        left: 50%;
    }

    &__label input[type="radio"]:not(:checked)+.radio__tick::before {
        opacity: 0;
        transform: translate(-50%, -50%) scale(0);
    }

    &__label input[type="radio"]:checked+.radio__tick::before {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
    }
}
</style>
